import React from "react";
import RightServiceButtonSection2 from "./RightServiceButtonSection2";
import RightServiceCategoriesSection2 from "./RightServiceCategoriesSection2";
import RightServiceInstaSection2 from "./RightServiceInstaSection2";
import RightServiceRecentSection2 from "./RightServiceRecentSection2";

import fb1 from "../../../../images/aboutimage/fb1.jpg";
import fb2 from "../../../../images/aboutimage/fb2.jpg";
import fb3 from "../../../../images/aboutimage/fb3.jpg";
import advertise from "../../../../images/aboutimage/advertise.jpg";
const RightServiceSection2 = () => {
  return (
    <div className="right-blog mt-9 lg:w-[30%]">
      {/* <div className="B1 rounded-sm border pt-6 pb-6">
        <h1 className="mx-8 text-4xl font-bold">Search</h1>
        <input
          className="mx-9 mt-4 h-16 w-10/12 rounded-md bg-slate-200 p-6 font-mono text-xl"
          type="text"
          placeholder="Search here"
          required
        />
      </div> */}
      <div className="B1 mt-12 border pt-8 pb-5">
        <h1 className="mx-8 text-4xl font-bold">All Categories</h1>
        <ul className="mx-8 pt-8 text-xl text-gray-500">
          <RightServiceCategoriesSection2 activity="Painting" />
          <RightServiceCategoriesSection2 activity="Debate" />
          <RightServiceCategoriesSection2 activity="Quiz " />
          <RightServiceCategoriesSection2 activity="Dancing" />
          <RightServiceCategoriesSection2 activity="Singing" />
          <RightServiceCategoriesSection2 activity="Preparing Charts" />
          <RightServiceCategoriesSection2 activity="Organizing exhibitions & many more " />
        </ul>
      </div>
      <div className="B1 mt-12 rounded-sm border px-7 pt-8 pb-10">
        <h1 className="text-4xl font-bold">Facebook post</h1>
        <RightServiceRecentSection2
          image={fb1}
          date="14 mar"
          description="WORLD ENVIORNMENT DAY"
        />
        <RightServiceRecentSection2
          image={fb2}
          date="3 apr"
          description="FATHER'S DAY"
        />
        <RightServiceRecentSection2
          image={fb3}
          date=" 5 sept"
          description=" TEACHER'S DAY"
        />
      </div>
      <div className="B1  mt-12 rounded-sm border px-7 pt-8 pb-10">
        <h1 className="text-4xl font-bold">Instagram post</h1>
        <RightServiceInstaSection2 row="top" />
        <RightServiceInstaSection2 row="bottom" />
      </div>
      <div className="B1 mt-12 rounded-sm border px-7 pt-8 pb-10 ">
        <h1 className="text-4xl font-bold">Golden Words</h1>
        <ul>
          <RightServiceButtonSection2 button="Be honest" />
          <RightServiceButtonSection2 button=" Responsible" />
          <RightServiceButtonSection2 button="Be kind " />
          <RightServiceButtonSection2 button="Learn daily" />
          <RightServiceButtonSection2 button="Stay happy" />
          <RightServiceButtonSection2 button="Be consistent" />
          {/* <RightServiceButtonSection2 button=""/>
         
          <RightServiceButtonSection2 button=""/>
          <RightServiceButtonSection2 button=""/> */}
        </ul>
      </div>
      <div className="B1 mt-12 border px-7 pt-8 pb-10">
        <h1 className="text-4xl font-bold">Advertisement</h1>
        <img
          className="cursor-pointer rounded-sm pt-10"
          src={advertise}
          alt=""
        />
      </div>
    </div>
  );
};

export default RightServiceSection2;
